import axios from "axios";


async function fetchOSToken(contractAddress: string, tokenId: string) {
    try {
        let res = await axios.get(
            `https://api.opensea.io/api/v1/asset/${contractAddress}/${tokenId}/?include_orders=false`
        );
        if (res.status === 200 && res.data) {
            return res.data.image_url;
        }
    } catch (error) {
        console.log(error);
    }
}

export default fetchOSToken